import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";
import { COOKIE_BANNER } from "../../data/content";
import { useLang } from "../../context/LanguageContext";

const KEY = "af_cookie_consent";

export const CookieBanner = () => {
  const { lang } = useLang();
  const t = COOKIE_BANNER[lang];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[95] rounded-2xl border border-white/15 bg-[#0A0A0A]/90 backdrop-blur-xl p-5 shadow-2xl shadow-black/50"
        >
          <div className="flex items-start gap-3">
            <span className="w-10 h-10 shrink-0 rounded-xl bg-blue-500/10 border border-blue-500/25 flex items-center justify-center">
              <Cookie size={20} weight="duotone" className="text-blue-400" />
            </span>
            <div className="flex-1">
              <p className="text-sm text-zinc-300 leading-relaxed">
                {t.text}{" "}
                <Link to="/legal/cookie" data-testid="cookie-more" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">
                  {t.more}
                </Link>
              </p>
              <div className="mt-4 flex gap-3">
                <button data-testid="cookie-accept" onClick={() => decide("accepted")}
                  className="flex-1 rounded-full bg-blue-500 text-white text-sm font-semibold py-2.5 hover:bg-blue-400 transition-colors">
                  {t.accept}
                </button>
                <button data-testid="cookie-reject" onClick={() => decide("rejected")}
                  className="flex-1 rounded-full border border-white/20 text-zinc-300 text-sm font-semibold py-2.5 hover:bg-white/5 transition-colors">
                  {t.reject}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
